<template>
  <footer class="site-footer d-flex justify-content-center gap-4">
    <span>Copyright Hawaiian Electric {{ thisYear() }} - All Rights Reserved</span>
  </footer>
</template>

<script setup>
import { thisYear } from '@shared/utils/date'
</script>
